import CommonRoutes from '@routes/common-routes'

const allRoutes = []
const routes = allRoutes.concat(CommonRoutes)

export default routes
